// Conservative LGV video draft policies and supported format resolution.
// Provider limits vary; these limits do not assert API publishing support.
import { getPromotionSizedPostType, getSupportedPostTypesForPlatform } from "./promotion_post_types";

export const PROMOTION_VIDEO_MAX_BYTES = 100 * 1024 * 1024;
export const PROMOTION_VIDEO_MIN_SECONDS = 5;
export const PROMOTION_VIDEO_MAX_SECONDS = 60;
export const PROMOTION_VIDEO_MAX_DIMENSION = 4096;
const VIDEO_TYPES = new Set(["video", "reel", "short_video", "video_story"]);
const HELP_URLS = {
  facebook: "https://developers.facebook.com/docs/video-api/guides/reels-publishing/",
  instagram: "https://developers.facebook.com/docs/instagram-platform/content-publishing/",
  linkedin: "https://learn.microsoft.com/en-us/linkedin/marketing/community-management/shares/videos-api",
  tiktok: "https://developers.tiktok.com/docs/en/content-posting-api-media-transfer-guide",
};

export function getPromotionVideoConstraints(platform, postType) {
  const format = getPromotionSizedPostType(platform, postType)
    || getSupportedPostTypesForPlatform(platform).find((type) => type.key === postType);
  if (!format || !VIDEO_TYPES.has(format.baseType || format.key)) return null;
  return {
    maxBytes: PROMOTION_VIDEO_MAX_BYTES,
    minSeconds: PROMOTION_VIDEO_MIN_SECONDS,
    maxSeconds: PROMOTION_VIDEO_MAX_SECONDS,
    maxDimension: PROMOTION_VIDEO_MAX_DIMENSION,
    recommendedWidth: format.width || null,
    recommendedHeight: format.height || null,
    helpUrl: HELP_URLS[platform],
  };
}
